// extracted by mini-css-extract-plugin
export default {"clients":"HomePage_clients__O2-bY","content":"HomePage_content__eo633"};